// ---------------------------------------------------------------------------
// A5: Workflow Step Execution Logs
// ---------------------------------------------------------------------------
// Append-only log of every step executed in a workflow enrollment.
// Used for debugging, audit trail, and execution replay.
// PII sanitized before storage — input/output contain IDs only, not raw data.

import { pgTable, uuid, text, integer, jsonb, timestamp, index } from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

export const workflowStepLogs = pgTable(
  "workflow_step_logs",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    enrollmentId: text("enrollment_id").notNull(),
    workflowId: uuid("workflow_id").notNull(),
    nodeId: text("node_id").notNull(),
    actionRef: text("action_ref").notNull(),
    status: text("status").notNull(), // "success" | "failed" | "skipped" | "filtered_out"
    input: jsonb("input").$type<Record<string, unknown>>(), // PII-sanitized config
    output: jsonb("output").$type<Record<string, unknown>>(), // PII-sanitized result
    errorMessage: text("error_message"),
    durationMs: integer("duration_ms"),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  },
  (table) => [
    index("idx_step_logs_enrollment").on(table.tenantId, table.enrollmentId),
    index("idx_step_logs_workflow").on(table.tenantId, table.workflowId),
    index("idx_step_logs_created").on(table.tenantId, table.createdAt),
  ],
);
